module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [(_vm.slides.length == 1) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "block"
    },
    attrs: {
      "src": _vm.slides[0].imgUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slides.length > 1) ? _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.slides), function(itemImg, index) {
    return _c('swiper-slide', {
      key: itemImg.imgUrl
    }, [_c('img', {
      attrs: {
        "src": itemImg.imgUrl
      },
      on: {
        "click": function($event) {
          _vm.clickEvent(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slides.length > 1),
      expression: "slides.length>1"
    }],
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193fe9cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tplCommon/swiper/swiper.vue
// module id = 773
// module chunks = 10